/*
 * NsUI | 表单处理
 * @作者：             丘宇文
 * @QQ：               80232265
 * @文档地址：         https://NsUI.nishi.io
 * @社区地址：         https://nishi.io
 * @github地址：       https://github.com/kejiaren/NsUI
 */

import radio from "./radio";

import checkbox from "./checkbox";

// import select from "./select";




// WEBPACK FOOTER //
// src/js/from.js